import React from 'react';
import { useGetStorefrontQuery } from '../../Api/Api';

interface ICurrencyFormatProps {
    value: number;
    strikeThrough?: boolean;
}

const CurrencyFormat: React.FC<ICurrencyFormatProps> = (props) => {
    const sfSettings = useGetStorefrontQuery();
    return (
        <span style={props.strikeThrough ? {textDecoration: 'line-through'} : {}}>{new Intl.NumberFormat('en-US', { style: 'currency', currency: sfSettings.data?.currency }).format(props.value)}</span>
    );
}

export default CurrencyFormat;